module.exports = __webpack_public_path__ + "img/btn_green_hover.19eb32b6.webp";